import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;


@Component({
  selector: 'app-affiliate-ipds',
  templateUrl: './affiliate-ipds.component.html',
  styleUrls: ['./affiliate-ipds.component.css']
})
export class AffiliateIpdsComponent implements OnInit {

  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;

  perpage: number = 25; ipds: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; role: string; pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; search: string; currentUserId: any; booleanValue: any = false; treatment = ''; treatments = []; treatments_copy = []; city = ""; cities = []; cities_copy = []; sc3Url: string = ''; payment_mode = ''; status = ''; gender: string; doctors = []; doctors_copy = []; doctor: string;userId:string;
  start_date: string = ''; end_date: string = '';
  constructor(private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item:string) => {this.role=item;});
    this.role = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url = localStorage.getItem('s3url');
    this.getTreatment(); this.getcitiesList(); this.getDoctor();
  }


  ngAfterViewInit() {
    this.loadIpds(0, this.perpage);
  }

  setSearchValue(type) {
    if (type == 'treatment') {
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments = this.treatments_copy;
    } else if (type == 'city') {
      $("#citySearch").val('');
      $("#citySearch").focus();
      this.cities = this.cities_copy;
    } else if (type == 'doctor') {
      $("#doctorSearch").val('');
      $("#doctorSearch").focus();
      this.doctors = this.doctors_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    } else if (type == 'city') {
      this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
    } else if (type == 'doctor') {
      this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
    }
  }

  async loadIpds(pageIndex, perpage) {
    this.ipds = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&treatment=' + this.treatment + '&city=' + this.city + '&payment_mode=' + this.payment_mode + '&gender=' + this.gender + '&doctor=' + this.doctor + '&date_range=' + this.start_date + '-' + this.end_date;
    this.loading = true; this.loaded = false;
    await this.leadapi.getAffiliateIpds(this.paginator.pageIndex, perpage, qString)
      .subscribe((data: any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if (data.status) {
          this.ipds = data.data;
        } else {
          this.ipds = [];
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.loading = false;
        this.loaded = true;
        this.sharedapi.checkError(error);
      });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadIpds(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadIpds(event.pageIndex, event.pageSize);
  }

  async getTreatment() {
    await this.leadapi.getTreatments().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.data;
        this.treatments_copy = this.treatments;
      } else {
        this.treatments = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getcitiesList() {
    await this.leadapi.getcities().subscribe((data: any) => {
      if (data.status) {
        this.cities = data.data;
        this.cities_copy = this.cities;
      } else {
        this.cities = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  resetFilters() {
    this.clearDate();
    this.search = ''; this.treatment = ''; this.city = ''; this.payment_mode = ''; this.status = ''; this.gender = ''; this.doctor = '';
    this.loadIpds(0, 25);
  }

  getPaymentType(payment_type) {
    return this.sharedapi.getPaymentType(payment_type);
  }

  getRoomCategory(room) {
    return this.sharedapi.getRoomCategory(room);
  }

  async getDoctor() {
    await this.leadapi.getdoctors().subscribe((data: any) => {
      if (data.status) {
        this.doctors = data.data;
        this.doctors_copy = this.doctors;
      } else {
        this.doctors = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }


}
